import React from "react";
import AddressDetails from "../../../../../components/customers/customer-details/address-details";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useState } from "react";
import { CustomerTempContainer } from "../../../../../components/customers/customer-details/container";

export default function AddressEditPage() {
  let { id } = useParams();
  const addresses = useSelector((state) => state.customerTempReducer.addresses);
  const address = addresses.find((item) => item.id == id);
  const initForm = !!address ? address : {};
  const [form, setForm] = useState(initForm);

  const dispatch = useDispatch();
  const container = CustomerTempContainer(dispatch);
  function saveForm() {
    container.UpdateAddress(form);
  }
  return (
    <div>
      <AddressDetails
        form={form}
        setForm={setForm}
        saveForm={saveForm}
      ></AddressDetails>
    </div>
  );
}
